import React, { useEffect, useState } from "react";
import {
	Container,
	Box,
	Typography,
	Card,
	CardContent,
	Divider,
	useTheme,
	Button as MUIButton,
} from "@mui/material";
import NavbarCustomer from "../../components/NavbarCustomer";
import ResponsiveAppBar from "../../components/ResponsiveAppBar";

import { useDispatch, useSelector } from "react-redux";
import {
	setFormData,
	setResendEmail,
	setSubmitting,
	setUser,
	toggleCheckBox,
} from "../../store/features/authSlice";
import {
	closeModals,
	toggleAdditional,
	toggleLogin,
	toggleSocial,
} from "../../store/features/modalSlice";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import { Apple, Facebook, Google } from "../../svgs";
import Button from "../../components/shared/Button";
import CustomCheckBox from "../../components/shared/CustomCheckbox";
import CustomInput from "../../components/shared/CustomInput";
import { useNavigate } from "react-router-dom";
import { resetFormData } from "../../store/features/authSlice";
import { base_URL } from "../../config/config";
import { toast } from "react-toastify";
import axios from "axios";
import backgroundIcon from "../../assets/images/background_icon.svg";
import User from "../../assets/img/user.png";
import OutlinedLabelledTextField from "../../components/OutlinedLabelledTextfield";

export default function UserSignUp() {
	const customer = JSON.parse(localStorage.getItem("authUser")) || null;
	const customerId = customer?._id || null;
	return (
		<div className="flex flex-col h-screen">
			{customerId ? (
				<div className="z-[999]">
					<NavbarCustomer />
				</div>
			) : (
				<div className="z-[9999]">
					<ResponsiveAppBar />
				</div>
			)}
			<SignUpModal />
		</div>
	);
}
const SignUpModal = () => {
	const theme = useTheme();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { formData, isSubmitting } = useSelector((state) => state.auth);
	const [error, setError] = React.useState({
		fullName: "",
		email: "",
		password: "",
		confirmPassword: "",
	});
	const [isValidForm, setIsValidForm] = useState(false);

	const onLoginClick = () => navigate("/user-login");
	const onSocialClick = () => dispatch(toggleSocial());

	const handleChange = (e) => {
		const { name, value } = e.target;

		// Update form data
		dispatch(setFormData({ name, value }));

		// Sync email with resendEmail field
		if (name === "email") {
			dispatch(setResendEmail(value)); // Sync resendEmail with the email field
		}
	};

	const isFormValid = () => {
		let values = Object.values(formData);
		let isValid = true;
		for (let value of values)
			if (typeof value === "string" && (value === "" || !value))
				isValid = false;
		return isValid;
	};

	const handleCheckBox = () => {
		dispatch(toggleCheckBox());
	};

	const validatePassword = (password) => {
		const minLength = 8;
		const hasNumber = /\d/;
		const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/;

		if (password.length < minLength) {
			setError((prev) => ({
				...prev,
				password: "Password must be at least 8 characters long.",
			}));
			return false;
		}
		if (!hasNumber.test(password)) {
			setError((prev) => ({
				...prev,
				password: "Password must contain at least one number.",
			}));
			return false;
		}
		if (!hasSpecialChar.test(password)) {
			setError((prev) => ({
				...prev,
				password: "Password must contain at least one special character.",
			}));
			return false;
		}
		return true;
	};
	const doPasswordsMatch = (password, confirmPassword) => {
		return password === confirmPassword;
	};

	const validateForm = () => {
		const { fullName, email, password, confirmPassword } = formData;

		// Clear previous errors
		setError({ fullName: "", email: "", password: "", confirmPassword: "" });

		if (!fullName) {
			setError((prev) => ({
				...prev,
				fullName: "Full name is required.",
			}));
		}

		if (!email) {
			setError((prev) => ({
				...prev,
				email: "Email address is required.",
			}));
		}
		if (email) {
			const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
			if (!emailPattern.test(email)) {
				setError((prev) => ({
					...prev,
					email: "Please enter a valid email address.",
				}));
				return false;
			}
		}

		if (!password || password.length < 8) {
			setError((prev) => ({
				...prev,
				password: "Password must be atleast 8 characters long.",
			}));
		}

		if (!confirmPassword) {
			setError((prev) => ({
				...prev,
				confirmPassword: "Please confirm your password.",
			}));
			return false;
		}

		if (password !== confirmPassword) {
			setError((prev) => ({
				...prev,
				confirmPassword: "Passwords do not match.",
			}));
			return false;
		}

		if (!validatePassword(password)) {
			return false;
		}

		return true;
	};

	const onSubmit = () => {
		// console.log("click");

		dispatch(setSubmitting(true));

		if (!validateForm()) {
			dispatch(setSubmitting(false));
			return;
		}

		dispatch(toggleAdditional());
		dispatch(setSubmitting(false));
	};

	//  Facebook login handler
	const handleFacebookResponse = async (response) => {
		try {
			if (response.accessToken) {
				const result = await axios.get(
					`${base_URL}/api/auth/facebook?access_token=${response.accessToken}`
				);
				const { data, token } = result.data;

				dispatch(setUser(data));
				dispatch(closeModals());

				localStorage.setItem("authToken", token);
				localStorage.setItem("authUser", JSON.stringify(data));

				toast.success("Logged in successfully!");
				navigate("/");
			}
		} catch (error) {
			console.error("Facebook login error:", error);
			toast.error(
				error.response?.data?.message || "Failed to login with Facebook"
			);
		}
	};
	useEffect(() => {
		// Initialize Facebook SDK
		window.fbAsyncInit = function () {
			window.FB.init({
				appId: process.env.REACT_APP_FACEBOOK_APP_ID,
				cookie: true,
				xfbml: true,
				version: "v17.0",
			});
		};

		// Load Facebook SDK
		(function (d, s, id) {
			var js,
				fjs = d.getElementsByTagName(s)[0];
			if (d.getElementById(id)) return;
			js = d.createElement(s);
			js.id = id;
			js.src = "https://connect.facebook.net/en_US/sdk.js";
			fjs.parentNode.insertBefore(js, fjs);
		})(document, "script", "facebook-jssdk");
	}, []);

	useEffect(() => {
		setIsValidForm(isFormValid());
	}, [formData, dispatch]);

	return (
		// <div>
		// 	<div
		// 		onClick={() => {
		// 			navigate("/register");
		// 			dispatch(closeModals());
		// 			dispatch(resetFormData());
		// 		}}
		// 		className="text-dark cursor-pointer mb-0 underline mx-auto w-full text-center"
		// 	>
		// 		Register as Vendor
		// 	</div>
		// 	<p className="text-center text-gray">
		// 		Already have an account?{" "}
		// 		<span
		// 			onClick={onLoginClick}
		// 			className="underline cursor-pointer font-medium text-black"
		// 		>
		// 			Log in
		// 		</span>
		// 	</p>

		// 	<div className="flex flex-col gap-4">
		// 		<CustomInput
		// 			label={"Full name"}
		// 			name={"fullName"}
		// 			type={"text"}
		// 			placeholder={"Enter your full name"}
		// 			value={formData.fullName}
		// 			onChange={handleChange}
		// 			error={error.fullName}
		// 		/>
		// 		<CustomInput
		// 			label={"Email address"}
		// 			name={"email"}
		// 			type={"text"}
		// 			placeholder={"Enter your email address"}
		// 			value={formData.email}
		// 			onChange={handleChange}
		// 			error={error.email}
		// 		/>
		// 		<CustomInput
		// 			label={"Password"}
		// 			name={"password"}
		// 			type={"password"}
		// 			placeholder={"Enter your password"}
		// 			value={formData.password}
		// 			onChange={handleChange}
		// 			error={error.password}
		// 		/>
		// 		<CustomInput
		// 			label={"Confirm Password"}
		// 			name={"confirmPassword"}
		// 			type={"password"}
		// 			placeholder={"Enter your password again"}
		// 			value={formData.confirmPassword}
		// 			onChange={handleChange}
		// 			error={error.confirmPassword}
		// 		/>
		// 		<div className="mt-2">
		// 			<CustomCheckBox
		// 				label={
		// 					<span>
		// 						<span className="font-[500]">Newsletter subscription</span>
		// 						<br />
		// 						Receive announcements, recommendations, and updates about
		// 						Findmyvenue
		// 					</span>
		// 				}
		// 				isChecked={formData.newsletterSubscription}
		// 				onChange={handleCheckBox}
		// 			/>
		// 		</div>

		// 		<Button
		// 			onClick={onSubmit}
		// 			label={isSubmitting ? "Signing up..." : "Sign up"}
		// 			disabled={isSubmitting}
		// 		/>

		// 		<div className="flex gap-2 justify-center w-full">
		// 			<FacebookLogin
		// 				appId={process.env.REACT_APP_FACEBOOK_APP_ID}
		// 				autoLoad={false}
		// 				fields="name,email,picture"
		// 				callback={handleFacebookResponse}
		// 				render={(renderProps) => (
		// 					<div
		// 						className="border cursor-pointer justify-center flex border-dark rounded-md w-full px-4 py-2"
		// 						onClick={renderProps.onClick}
		// 					>
		// 						<Facebook />
		// 					</div>
		// 				)}
		// 			/>

		// 			{/* Apple Button */}
		// 			<button className="border justify-center flex border-dark rounded-md w-full px-4 py-2">
		// 				<Apple />
		// 			</button>

		// 			{/* Google Button */}
		// 			<button
		// 				onClick={onSocialClick}
		// 				className="border justify-center flex border-dark rounded-md w-full px-4 py-2"
		// 			>
		// 				<Google />
		// 			</button>
		// 		</div>
		// 	</div>
		// </div>
		<div
			style={{
				backgroundImage: `url(${backgroundIcon})`,
				backgroundSize: "contain",
				backgroundRepeat: "no-repeat",
				backgroundPosition: "right",
				minHeight: "75vh",
				paddingBottom: "3rem",
			}}
		>
			<Container>
				<Box
					sx={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						flexDirection: "column",
					}}
				>
					<Typography
						variant="h4"
						gutterBottom
						sx={{
							mt: { xs: 5, md: 10 },
							fontWeight: "bold",
							fontSize: { xs: "1.8rem" },
						}}
					>
						<div className="flex items-center space-x-4">
							<img src={User} alt="user" className="h-10" />
							<span>User signup</span>
						</div>
					</Typography>
				</Box>
			</Container>

			<Container
				maxWidth="sm"
				sx={{ display: "flex", justifyContent: "center" }}
			>
				<Box
					sx={{
						mt: 3,
						width: { xs: "95%", md: "80%" },
						display: "flex",
						flexDirection: "column",
						justifyContent: "center",
						gap: 1,
					}}
				>
					<OutlinedLabelledTextField
						id={"fullName"}
						label="Full name"
						isChecked="fullName"
						type="text"
						placeholder="Enter your full name"
						value={formData.fullName}
						onChange={handleChange}
						error={error.fullName}
					/>
					<OutlinedLabelledTextField
						label="Email address"
						id="email"
						type="text"
						placeholder="Enter your email address"
						value={formData.email}
						onChange={handleChange}
						error={error.email}
						helperText={error.email}
					/>
					<OutlinedLabelledTextField
						label="Password"
						id="password"
						type="password"
						placeholder="Enter your password"
						value={formData.password}
						onChange={handleChange}
						error={error.password}
						helperText={error.password}
					/>
					<OutlinedLabelledTextField
						label="Confirm Password"
						id="confirmPassword"
						type="password"
						placeholder="Enter your password again"
						value={formData.confirmPassword}
						onChange={handleChange}
						error={error.confirmPassword}
						helperText={error.confirmPassword}
					/>

					<Box mt={2}>
						<CustomCheckBox
							label={
								<span>
									<span className="font-[500]">Newsletter subscription</span>
									<br />
									Receive announcements, recommendations, and updates about
									Findmyvenue
								</span>
							}
							isChecked={formData.newsletterSubscription}
							onChange={handleCheckBox}
						/>
					</Box>

					<MUIButton
						onClick={onSubmit}
						disabled={isSubmitting || !isValidForm}
						type="submit"
						variant="contained"
						fullWidth
						size="large"
						sx={{
							mb: { xs: 1, md: 3 },
							borderRadius: "8px",
							mt: 2,
							backgroundColor: isFormValid() ? "primary.main" : "grey.border",
							color: isFormValid() ? "white" : "text",
						}}
					>
						{isSubmitting ? "Signing up..." : "Sign up"}
					</MUIButton>

					<Box
						sx={{ display: "flex", justifyContent: "center", gap: 2, mt: 3 }}
					>
						<FacebookLogin
							appId={process.env.REACT_APP_FACEBOOK_APP_ID}
							autoLoad={false}
							fields="name,email,picture"
							callback={handleFacebookResponse}
							render={(renderProps) => (
								<Box
									className="border border-dark rounded-md px-4 py-2 cursor-pointer"
									onClick={renderProps.onClick}
									sx={{
										display: "flex",
										justifyContent: "center",
										alignItems: "center",
										width: "100%",
									}}
								>
									<Facebook />
								</Box>
							)}
						/>

						<Box
							className="border border-dark rounded-md px-4 py-2"
							sx={{
								display: "flex",
								justifyContent: "center",
								width: "100%",
								alignItems: "center",
							}}
						>
							<Apple />
						</Box>

						<Box
							onClick={onSocialClick}
							className="border border-dark rounded-md px-4 py-2 cursor-pointer"
							sx={{
								display: "flex",
								justifyContent: "center",
								width: "100%",
								alignItems: "center",
							}}
						>
							<Google />
						</Box>
					</Box>

					<Divider sx={{ my: 1 }} />

					<Typography
						variant="body1"
						sx={{ textAlign: "center", color: "grey.text" }}
					>
						Already have an account?{" "}
						<span
							onClick={onLoginClick}
							className="underline cursor-pointer font-medium mb-3"
							style={{ color: theme.palette.primary.main }}
						>
							Log in
						</span>
					</Typography>
				</Box>
			</Container>
		</div>
	);
};
